import { de, en, es, fr, it, nl, pl } from "@onesolution/translations";

export const LANG_MAPPER: Record<AvailableLanguages, unknown> = {
	de: de,
	en: en,
	es: es,
	fr: fr,
	it: it,
	nl: nl,
	pl: pl,
};

export enum AvailableLanguages {
	FR = "fr",
	EN = "en",
	DE = "de",
	NL = "nl",
	PL = "pl",
	IT = "it",
	ES = "es",
}

export const langOptions = [
	{
		key: AvailableLanguages.EN,
		name: "English",
	},
	{
		key: AvailableLanguages.FR,
		name: "Français",
	},
	{
		key: AvailableLanguages.IT,
		name: "Italiano",
	},
	{
		key: AvailableLanguages.DE,
		name: "Deutsch",
	},
	{
		key: AvailableLanguages.ES,
		name: "Español",
	},
	{
		key: AvailableLanguages.NL,
		name: "Nederlands",
	},
	{
		key: AvailableLanguages.PL,
		name: "Polski",
	},
];

export const DEFAULT_LANGUAGE = AvailableLanguages.EN;

export const LS_LANGUAGE_KEY = "ONESOLUTION-LANGUAGE";

export { default as DEFAULT_TRANSLATIONS } from "@onesolution/translations/en.json";
